import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, ErrorStateMatcher } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'kt-mode-warn-dialog',
  templateUrl: './mode-warn.component.html'
})
export class ModeWarnComponent implements OnInit  {

	constructor(public dialogRef: MatDialogRef<ModeWarnComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

	ngOnInit() {

	}

	onOk() {
		this.dialogRef.close({success: true});
	}

}
